import React from 'react'
import PropTypes from 'prop-types'
import { ReadMoreLink } from './styles'

const Link = ({ text, href, onClick }) => (
  <ReadMoreLink href={href} target="_blank" rel="noopener noreferrer" onClick={onClick}>
    {text}
  </ReadMoreLink>
)

Link.propTypes = {
  text: PropTypes.string.isRequired,
  href: PropTypes.string,
  onClick: PropTypes.func,
}

export default Link
